import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import stripeServices from "../services/stripeServices";
import { loadStripe } from "@stripe/stripe-js";
import useNotify from "../hooks/useNotify";
import { useNavigate } from "react-router-dom";

const useStripePaiement = () => {
  const { api } = useContext(AuthContext);
  const service = new stripeServices(api);
  const { notifyArticlePublished } = useNotify();

  const createPaiement = async (data,params) => {
    return service.create(data,params);
  };
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  );


  return {
    stripePromise,
    createPaiement,
  };
};

export default useStripePaiement;
